<template>
  <div class="flex flex-col p-4 bg-white rounded-lg mx-4 shadow-lg relative">
    <!-- Premade messages picker -->
    <premade-messages-popup
      v-model="showPremadeMessages"
      v-on:onSubmitMessage="sendPremadeMessage"
      :venueId="activeConversation.venueId"
      :templateType="type == 'email' ? 'html' : 'plain'"
    />

    <!-- Top part -->
    <div class="flex px-8 mx-2 pb-2 items-center">
      <vs-dropdown
        vs-trigger-click
        vs-custom-content
        class="cursor-pointer mr-1"
      >
        <vs-chip color="primary">
          <vs-avatar icon="info" class="avatar-icon-lg" />
          {{ activeConversation.status | formatWord }}
        </vs-chip>
        <vs-dropdown-menu>
          <vs-dropdown-item
            v-if="activeConversation.status != 'CLOSED'"
            @click="setStatus('CLOSED')"
          >
            Close
          </vs-dropdown-item>
          <vs-dropdown-item
            v-if="activeConversation.status != 'OPEN'"
            @click="setStatus('OPEN')"
          >
            Open
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>

      <GRUserSelector
        :conversation="activeConversation"
        @onAssign="setAssigned"
        class="mr-1"
      >
        <vs-chip color="primary">
          <vs-avatar icon="account_circle" class="avatar-icon-lg" />
          {{
            activeConversation.assignee
              ? activeConversation.assignee.userDisplayName
              : "Unassigned"
          }}
        </vs-chip>
      </GRUserSelector>

      <vs-chip
        v-for="topic in activeConversation.topics"
        :key="topic.topic"
        :color="topic.color"
        closable
        class="mr-1"
        @click="removeTopic(topic)"
      >
        {{ topic.topic }}
      </vs-chip>

      <vs-dropdown vs-trigger-click vs-custom-content class="cursor-pointer">
        <vs-chip color="grey"> + Add topic </vs-chip>
        <vs-dropdown-menu>
          <div class="flex flex-wrap max-w-xs gap-2">
            <vs-chip
              v-for="topic in filteredPickableTopics"
              :key="topic.topic"
              :color="topic.color"
              class="cursor-pointer"
              @click.native="addTopic(topic)"
            >
              {{ topic.topic }}
            </vs-chip>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <!-- Input field and send button -->
    <div class="flex flex-grow items-center">
      <vs-dropdown vs-trigger-click vs-custom-content class="cursor-pointer">
        <feather-icon class="mr-2 cursor-pointer" icon="PlusCircleIcon" />
        <vs-dropdown-menu>
          <vs-dropdown-item @click="showPremadeMessages = !showPremadeMessages">
            <div class="flex items-center">
              <feather-icon class="cursor-pointer" icon="PenToolIcon" />
              <span class="ml-2"> Premade messages </span>
            </div>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>

      <div v-if="type == 'chat'" class="flex flex-grow relative">
        <vs-textarea
          ref="plainTextarea"
          class="flex-1 input-send-message"
          :placeholder="
            isActiveAssignee
              ? 'Type Your Message'
              : 'You must be assigned to the conversation to type'
          "
          v-model="typedMessage"
          :disabled="!isActiveAssignee"
        />
        <!-- @keyup.enter.exact="sendMsg" -->

        <div class="flex items-center absolute right-0 top-0 bottom-0 pr-3">
          <!-- <feather-icon
                  class="ml-2 cursor-pointer"
                  icon="ImageIcon"
                  @click="showPremadeMessages = !showPremadeMessages"
                /> -->
          <feather-icon
            class="ml-2 cursor-pointer"
            icon="SmileIcon"
            @click="showEmojiPicker = !showEmojiPicker"
          />
        </div>
      </div>

      <quill-editor
        v-if="type == 'email'"
        v-model="typedMessage"
        :options="editorOption"
        class="flex-grow"
        :disabled="!isActiveAssignee"
        ref="quillTextarea"
      />

      <!-- <div class="flex-grow">
        <editor
          v-model="typedMessage"
          api-key="7bj9jdd5cgv265adgst429iw3ix28q5apqgr4irrkuubk42h"
          :init="{
            plugins: [
              'advlist',
              'autolink',
              'lists',
              'link',
              'charmap',
              'preview',
              'anchor',
              'searchreplace',
              'visualblocks',
              'code',
              'fullscreen',
              'insertdatetime',
              'table',
              'help',
              'wordcount',
            ],
          }"
        />
      </div> -->

      <div v-if="type == 'email'" class="flex relative">
        <div class="flex items-center absolute right-0 pr-3" style="top: 10px">
          <feather-icon
            class="ml-2 cursor-pointer"
            icon="SmileIcon"
            @click="showEmojiPicker = !showEmojiPicker"
          />
        </div>
      </div>

      <vs-button
        class="bg-primary-gradient ml-4 hover-animate-send"
        type="filled"
        id="chat-send-button"
        @click="sendMsg"
        :class="{ sending: isSending }"
        :disabled="!isActiveAssignee || typedMessage.length == 0"
        radius
        icon="send"
      ></vs-button>
    </div>

    <transition name="fade-top-2x">
      <VEmojiPicker
        v-if="showEmojiPicker"
        class="emoji-picker"
        @select="selectEmoji"
      />
    </transition>
  </div>
</template>

<script>
import PremadeMessagesPopup from "./PremadeMessagesPopup.vue";
import { VEmojiPicker } from "v-emoji-picker";
import { mapGetters } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
// import Editor from "@tinymce/tinymce-vue";
import GRUserSelector from "./GRUserSelector.vue";

export default {
  components: {
    // Editor,
    quillEditor,
    PremadeMessagesPopup,
    VEmojiPicker,
    GRUserSelector,
  },
  props: ["type", "activeConversation"],
  data() {
    return {
      showEmojiPicker: false,
      showPremadeMessages: false,
      typedMessage: "",

      isSending: false,

      pickableTopics: [
        {
          color: "#ffb997",
          topic: "Important",
        },
        {
          color: "#f67e7d",
          topic: "Booking",
        },
        {
          color: "#843b62",
          topic: "Nightpay",
        },
        {
          color: "#0b032d",
          topic: "Feedback",
        },
        {
          color: "#44411a",
          topic: "Unrelated",
        },
      ],
      editorOption: {
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "link",
              "blockquote",
              "code-block",
            ],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ font: [] }],
          ],
        },
        placeholder:
          "Type Your Message. You must be assigned to this conversation to type",
      },
    };
  },
  computed: {
    ...mapGetters({
      userId: "users/userId",
    }),
    isActiveAssignee() {
      return (
        this.activeConversation.assignee &&
        this.activeConversation.assignee.userId == this.userId
      );
    },
    filteredPickableTopics() {
      if (!this.activeConversation) return this.pickableTopics;

      // Filter out topics already applied to the conversation
      const activeTopics = this.activeConversation.topics;
      console.log(activeTopics);
      return this.pickableTopics.filter(
        (e) =>
          !activeTopics.some((activeTopic) => activeTopic.topic === e.topic)
      );
    },
  },
  // Watcher that that clears the message when the conversation changes
  watch: {
    activeConversation: {
      handler: function () {
        this.typedMessage = "";
      },
      deep: true,
    },
  },
  methods: {
    addTopic(topic) {
      console.log("Want to add topic", topic, this.activeConversation.id);
      this.$store.dispatch(`${this.type}/addTopic`, {
        conversationId: this.activeConversation.id,
        conversationTopic: topic,
      });
    },
    removeTopic(topic) {
      console.log("Want to remove topic", topic, this.activeConversation.id);
      this.$store.dispatch(`${this.type}/removeTopic`, {
        conversationId: this.activeConversation.id,
        conversationTopic: topic,
      });
    },
    setStatus(status) {
      console.log("Want to update status", status, this.activeConversation.id);
      this.$store.dispatch(`${this.type}/setStatus`, {
        conversationId: this.activeConversation.id,
        status: status,
      });
    },
    setAssigned(userId) {
      console.log(
        "Want to update assignee",
        userId,
        this.activeConversation.id
      );
      this.$store.dispatch(`${this.type}/setAssignee`, {
        conversationId: this.activeConversation.id,
        assigneeId: userId,
      });
    },
    selectEmoji(emoji) {
      if (this.type == "chat") {
        const el = this.$refs.plainTextarea.$el.children[0];
        const [start, end] = [el.selectionStart, el.selectionEnd];
        el.setRangeText(emoji.data, start, end, "select");
        this.typedMessage = el.value;
      } else {
        const selection = this.$refs.quillTextarea.quill.getSelection(true);
        this.$refs.quillTextarea.quill.insertText(
          selection == null ? 0 : selection.index,
          emoji.data
        );
        // this.typedMessage += emoji.data;
      }

      // this.typedMessage += emoji.data;
      this.showEmojiPicker = false;
    },

    sendPremadeMessage(textMessage) {
      this.typedMessage = textMessage;
      //   this.sendMsg();
    },

    sendMsg() {
      if (!this.typedMessage) return;
      this.isSending = true;
      this.$emit("onSendMessage", this.typedMessage);
    },

    messageSent() {
      if (this.isSending) {
        this.typedMessage = "";
        this.isSending = false;
      }
    },
  },
};
</script>

<style lang="scss">
.tox.tox-silver-sink {
  z-index: 12312399;
}

.emoji-picker {
  position: absolute;
  z-index: 9999;
  bottom: 6rem;
  right: 1rem;
}

.input-send-message {
  margin-bottom: 0px;
  input.vs-input--input {
    padding-right: 40px !important;
    border-radius: 999px !important;
  }
}

#chat-send-button {
  &.sending {
    opacity: 0.5;
    pointer-events: none;
  }
}

.hover-animate-send {
  i {
    transition: all 0.2 ease-in-out;
    transform: none;
  }

  &:hover {
    i {
      transform: scale(1.2) rotate(-12deg);
    }
  }
}

.avatar-icon-lg {
  background-color: transparent !important;
  margin-right: -6px;
  * {
    font-size: 20px !important;
  }
}
</style>